import { httpApiModal } from './httpApiModal'
import { updateNodeConnections } from '../../utils/functions'
import { nanoid } from 'nanoid/async'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: httpApiData } = await httpApiModal(oldData, node)


  if (httpApiData && Object.values(httpApiData).length >= 0) {
    
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, httpApiData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}